import { LimitType } from 'legoland-sdk/dist/experimental';
import styled from 'styled-components';
import { Text, propStyling, tombac } from 'tombac';
import CountLimitSummary from "./limit-summaries/CountLimitSummary";
import DateLimitSummary from "./limit-summaries/DateLimitSummary";
import DateRangeLimitSummary from "./limit-summaries/DateRangeLimitSummary";
import GeoLimitSummary from "./limit-summaries/GeoLimitSummary";
import KmLimitSummary from "./limit-summaries/KmLimitSummary";
import SquareKmLimitSummary from "./limit-summaries/SquareKmLimitSummary";
import { jsx as _jsx } from "react/jsx-runtime";
const limitSummaryComponentMap = {
  [LimitType.Boolean]: () => null,
  [LimitType.Count]: CountLimitSummary,
  [LimitType.Date]: DateLimitSummary,
  [LimitType.DateRange]: DateRangeLimitSummary,
  [LimitType.Geo]: GeoLimitSummary,
  [LimitType.Km]: KmLimitSummary,
  [LimitType.SquareKm]: SquareKmLimitSummary
};
export const LimitSummary = _ref => {
  let {
    limit,
    schema,
    usage
  } = _ref;
  const SummaryComponent = limitSummaryComponentMap[schema.type];
  if (!SummaryComponent) {
    console.error(`Limit summary component for type ${schema.type} does not exist`);
    return null;
  }
  return limit !== null && /*#__PURE__*/_jsx(SummaryComponent, {
    limit: limit,
    schema: schema,
    usage: usage
  });
};
const ListContainer = styled.div.withConfig({
  displayName: "LimitSummaryList__ListContainer"
})(["display:grid;gap:", ";", ";"], tombac.space(1), propStyling);
export const LimitSummaryList = _ref2 => {
  let {
    limits,
    schemas,
    usages,
    ...propStyling
  } = _ref2;
  const limitsExist = limits && Object.values(limits).length > 0;
  return /*#__PURE__*/_jsx(ListContainer, {
    $gridTemplateColumns: "1fr",
    ...propStyling,
    "data-sentry-element": "ListContainer",
    "data-sentry-component": "LimitSummaryList",
    "data-sentry-source-file": "LimitSummaryList.tsx",
    children: limitsExist ? schemas.map(schemaItem => Object.hasOwn(limits, schemaItem.name) && /*#__PURE__*/_jsx(LimitSummary, {
      limit: limits[schemaItem.name],
      schema: schemaItem,
      usage: usages && usages[schemaItem.name]
    }, schemaItem.name)) : /*#__PURE__*/_jsx(Text, {
      as: "span",
      $mt: "0.2em",
      children: "No limits are set."
    })
  });
};